import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { List, Item, Icon } from './styles';
export const IconListContext = /*#__PURE__*/createContext({});
const IconItem = ({
  className,
  icon: ogIcon,
  color: ogColor,
  children = null
}) => {
  const {
    icon: contextIcon,
    color: contextColor
  } = useContext(IconListContext);
  const icon = ogIcon || contextIcon;
  const color = ogColor || contextColor;
  return /*#__PURE__*/React.createElement(Item, {
    className: className
  }, icon ? /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    color: color
  }) : null, children);
};
IconItem.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string
};
const IconList = ({
  icon,
  children = null,
  color = 'accentPrimary2',
  className = ''
}) => {
  const providerValue = useMemo(() => ({
    color,
    icon
  }), [color, icon]);
  return /*#__PURE__*/React.createElement(IconListContext.Provider, {
    value: providerValue
  }, /*#__PURE__*/React.createElement(List, {
    className
  }, children));
};
IconList.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string
};
IconList.Item = IconItem;
export { IconItem };
export default IconList;
//# sourceMappingURL=index.js.map